/**
 * The periodic table of the survey page (`surveys/chemija-8/index.html`),
 * ported as it was: Z, symbol, Lithuanian name and the rounded school Ar
 * (Cl 35,5), periods 1–7 to radium, the lanthanide and actinide rows as two
 * placeholders. No metal/non-metal colouring, on purpose: where the metals
 * are is one of the questions. The survey and the player draw the same one,
 * the player beside a chemistry item (`ChildItem.aids`).
 */
export interface Element {
  z: number;
  sym: string;
  name: string;
  ar: string;
  period: number;
  group: number;
}

const EL = (
  "H vandenilis 1|He helis 4|Li litis 7|Be berilis 9|B boras 11|C anglis 12|N azotas 14|O deguonis 16|F fluoras 19|Ne neonas 20|" +
  "Na natris 23|Mg magnis 24|Al aliuminis 27|Si silicis 28|P fosforas 31|S siera 32|Cl chloras 35,5|Ar argonas 40|" +
  "K kalis 39|Ca kalcis 40|Sc skandis 45|Ti titanas 48|V vanadis 51|Cr chromas 52|Mn manganas 55|Fe geležis 56|Co kobaltas 59|Ni nikelis 59|Cu varis 64|Zn cinkas 65|Ga galis 70|Ge germanis 73|As arsenas 75|Se selenas 79|Br bromas 80|Kr kriptonas 84|" +
  "Rb rubidis 85|Sr stroncis 88|Y itris 89|Zr cirkonis 91|Nb niobis 93|Mo molibdenas 96|Tc technecis 98|Ru rutenis 101|Rh rodis 103|Pd paladis 106|Ag sidabras 108|Cd kadmis 112|In indis 115|Sn alavas 119|Sb stibis 122|Te telūras 128|I jodas 127|Xe ksenonas 131|" +
  "Cs cezis 133|Ba baris 137"
).split("|");
const EL6 = "Hf hafnis 178,5|Ta tantalas 181|W volframas 184|Re renis 186|Os osmis 190|Ir iridis 192|Pt platina 195|Au auksas 197|Hg gyvsidabris 201|Tl talis 204|Pb švinas 207|Bi bismutas 209|Po polonis 209|At astatas 210|Rn radonas 222".split("|");

/** Group headers, as on the page: the A-groups also by their old Roman numbers. */
export const GROUP_HEADS = ["1 IA", "2 IIA", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13 IIIA", "14 IVA", "15 VA", "16 VIA", "17 VIIA", "18 VIIIA"];

export function elements(): Element[] {
  const out: Element[] = [];
  const add = (z: number, s: string, period: number, group: number) => {
    const [sym, name, ar] = s.split(" ");
    out.push({ z, sym, name, ar, period, group });
  };
  EL.forEach((s, i) => {
    const z = i + 1;
    let p: number;
    let g: number;
    if (z <= 2) {
      p = 1;
      g = z === 1 ? 1 : 18;
    } else if (z <= 10) {
      p = 2;
      g = z <= 4 ? z - 2 : z + 8;
    } else if (z <= 18) {
      p = 3;
      g = z <= 12 ? z - 10 : z;
    } else if (z <= 36) {
      p = 4;
      g = z - 18;
    } else if (z <= 54) {
      p = 5;
      g = z - 36;
    } else {
      p = 6;
      g = z - 54;
    }
    add(z, s, p, g);
  });
  EL6.forEach((s, i) => add(72 + i, s, 6, 4 + i));
  add(87, "Fr francis 223", 7, 1);
  add(88, "Ra radis 226", 7, 2);
  return out;
}
